import { solutions } from '@/mocks/categories';

export default function SolutionsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            Solutions
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Explore VigorBuy Spreadsheet Solutions
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Discover specialized spreadsheet solutions tailored to different business needs and workflows.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {solutions.map((sol, idx) => (
            <div
              key={idx}
              className="group rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all overflow-hidden"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={sol.imageUrl}
                  alt={sol.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/90 backdrop-blur-sm text-primary-600">
                    <i className={`${sol.icon} text-lg`}></i>
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  {sol.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {sol.description}
                </p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Learn More
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}